
export const dmsDomains={
    DIVISION:{
        path:"divisions",
        name:"division",
    },
    PROGRAMME:{
        path:'programmes',
        name:"programme",
    },
    REGION:{
    path:'regions',
    name:'region'
    },
    DISTRICT:{
        path:'districts',
        name:'district'
    },
    FACILITY:{
        path:'facilities',
        name:'facility'
    },

  

}as const

export type IDmsDomains = (typeof dmsDomains)[keyof typeof dmsDomains];


export const dmsDomainsPaths = Object.values(dmsDomains).map(entry => entry.path);
export const dmsDomainsNames = Object.values(dmsDomains).map(entry => entry.name);

export type dmsDomainsPathsTy = typeof dmsDomainsPaths[number];
export type dmsDomainsNamesTy = typeof dmsDomainsNames[number];

export const getDomainLocationEndPoint = (name: dmsDomainsNamesTy): dmsDomainsPathsTy | undefined  => {
    const entry = Object.values(dmsDomains).find(item => item.name === name);
    return entry? entry.path:undefined ;
};